<template>
  <div class="code-modal">
    <div class="mask" @click="modalClose"></div>
    <div class="modal-container">
      <div class="modal-inner">
        <h5 class="title" v-html="data.title"></h5>
        <h6 class="sub-title" v-html="data.subTitle"></h6>

        <div v-if="data.isLocalCode" class="qr-code">
          <img class="qr-code-img" src="@images/h5_qr.jpg" />
        </div>
        <div v-else class="qr-code" ref="qrCodeUrl"></div>

        <div v-if="data.hasBtn" class="btn-area">
          <div class="button btn-block btn-pink link-btn" @click="btnAction">{{data.btnText}}</div>
        </div>
      </div>
      <div class="close-btn" @click="modalClose">✕</div>
    </div>
  </div>
</template>

<script>
import qrCode from 'qrcodejs2'
import { verify } from '@/utils'

export default {
  name: 'FollowModal',
  props: {
    data: Object
  },
  methods: {
    btnAction () {
      if (this.data.btnLink != '') {
        window.open(this.data.btnLink, '_blank')
      } else if (this.data.btnLink == '' && this.data.btnAction != '') {
        this.$emit(this.data.btnAction)
      }
    },
    creatQrCode () {
      let _url = window.location.href
      let qrcode
      if (verify.isMobile()) {
        qrcode = new qrCode(this.$refs.qrCodeUrl, {
          text: _url,
          width: 160,
          height: 160,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: qrCode.CorrectLevel.H
        })
      } else {
        qrcode = new qrCode(this.$refs.qrCodeUrl, {
          text: _url,
          width: 200,
          height: 200,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: qrCode.CorrectLevel.H
        })
      }
    },
    modalClose (e) {
      this.$emit('close')
    }
  },
  mounted () {
    if (!this.data.isLocalCode) {
      this.creatQrCode()
    }
  }
}
</script>

<style lang="scss" scoped>
.code-modal {
  position: fixed;
  z-index: 20;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  .mask {
    position: absolute;
    z-index: 0;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .65);
  }
  .modal-container {
    @include display-flex;
    position: absolute;
    z-index: 1;
    @include center();
    width: 80%;
    border-radius: 8px;
    align-items: center;
    justify-content: center;
    @include respond-to(desktop) {
      width: 280px;
    }
    .modal-inner {
      position: relative;
      width: 100%;
      padding: 60px 0;
      border-radius: 30px;
      text-align: center;
      background: linear-gradient(160deg, rgba(0, 40, 108, 0) 0%, #00286c 100%), #a911b1;
      background-size: cover;
      overflow: hidden;
      @include respond-to(desktop) {
        padding: 40px 0;
      }
    }
    .title {
      font-weight: 900;
      font-size: 2.8rem;
      text-align: center;
      color: #fff;
      @include respond-to(desktop) {
        margin-top: 0;
      }
    }
    .sub-title {
      font-weight: 500;
      text-align: center;
      color: #fff;
      @include respond-to(desktop) {
        font-size: 1.4rem;
      }
    }
    .qr-code {
      width: 160px;
      height: 160px;
      margin: 20px auto;
      .qr-code-img, /deep/ img {
        width: 100%;
        height: 100%;
      }
      @include respond-to(desktop) {
        width: 160px;
        height: 160px;
        margin: 20px auto;
      }
    }
    .btn-area {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 70px;
      .link-btn {
        height: 70px;
        line-height: 68px;
        padding: 0;
        font-size: 1.8rem;
      }
    }
    .close-btn {
      position: absolute;
      top: -50px;
      right: 0;
      z-index: 1;
      width: 40px;
      height: 40px;
      line-height: 40px;
      border: 2px solid #fff;
      border-radius: 50%;
      text-align: center;
      font-size: 2rem;
      font-weight: bold;
      color: #fff;
      cursor: pointer;
      @include respond-to(desktop) {
        top: -40px;
        right: -40px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FollowModal.vue